import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Typography,
  Box,
  CardContent,
  Toolbar,
  IconButton,
  Badge,
  Divider,
  Menu,
  MenuItem,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel,
  Checkbox,
  Tooltip,
  ListItemButton,
  ListItemText,
  List,
  ListSubheader,
  Card,
  CardHeader,
  ListItem,
  CardActions,
  ListItemAvatar,
  Avatar,
  Autocomplete,
  Stepper,
  Step,
  StepLabel,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";

import { Link, useLocation, useHistory } from "react-router-dom";

import { connect } from "react-redux";
import NoRecordMessage from "../../common/components/NoRecordMessage";

import { approveMembershipRequest } from "../../../../store/cpd/actions";

import { getSchoolSubLevelSubjects } from "../../../../store/posts/actions";

import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import ReactPaginate from "react-paginate";

import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import axios from "axios";
import { showError } from "../../../toastify";

import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { isEmpty } from "lodash";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";
import TrainingProviderProgramsDialog from "./TrainingProviderProgramsDialog";
import TrainingProviderAttachmentsDialog from "./TrainingProviderAttachmentsDialog";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const PreviewTrainingProviderDialog = (props) => {
  const {
    loading,
    user,
    approveMembershipRequest,
    showDialog,
    setShowDialog,
    request,

    programs,
    organizationTypes,
  } = props;

  // const [trainingTopics, setTrainingTopics] = useState([]);
  // const [trainingCohorts, setTrainingCohorts] = useState([]);
  // const [trainingMaterials, setTrainingMaterials] = useState([]);

  // const [showUploadedDocument, setShowUploadedDocument] = useState(false);

  // const [uploadedDocument, setUploadedDocument] = useState(null);

  // const getTrainingTopics = async (trainingId) => {
  //   try {
  //     const { data } = await axios.get(
  //       `/api/cpd/training-topics/${trainingId}`
  //     );

  //     setTrainingTopics(data);
  //   } catch (error) {}
  // };

  // const getTrainingCohorts = async (trainingId) => {
  //   try {
  //     const { data } = await axios.get(
  //       `/api/cpd/training-cohorts/${trainingId}`
  //     );

  //     setTrainingCohorts(data);
  //   } catch (error) {}
  // };

  // const getTrainingMaterials = async (trainingId) => {
  //   try {
  //     const { data } = await axios.get(
  //       `/api/cpd/training-materials/${trainingId}`
  //     );

  //     setTrainingMaterials(data);
  //   } catch (error) {}
  // };

  // useEffect(() => {
  //   getTrainingTopics(training.id);
  //   getTrainingCohorts(training.id);
  //   getTrainingMaterials(training.id);
  // }, [training]);

  const onClose = () => setShowDialog(false);

  // const [approvals, setApprovals] = useState({
  //   statusId: "",
  //   statusComments: "",
  // });

  const [statusId, setStatusId] = useState(null);
  const [statusComment, setStatusComment] = useState("");

  return (
    <Dialog onClose={onClose} open={showDialog} fullWidth maxWidth="md">
      <DialogTitle className="text-primary">
        {/* <Typography> */}
        <span className="text-primary text-uppercase">Training Provider</span>
        {/* </Typography> */}

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <span className="material-icons">close</span>
        </IconButton>
      </DialogTitle>
      <DialogContent className="px-5">
        <div className="row border rounded  p-3">
          <div className="col-8 text-left mt-2">
            <TextField
              required
              InputProps={{
                readOnly: true,
              }}
              fullWidth
              name="tinNumber"
              label="TIN Number"
              placeholder="TIN Number"
              variant="outlined"
              value={request.tinNumber || ""}
            />
          </div>
          <div className="col-4 text-left mt-2">
            <TextField
              required
              InputProps={{
                readOnly: true,
              }}
              fullWidth
              name="countryName"
              label="Country"
              placeholder="Country"
              variant="outlined"
              value={request.countryName || ""}
            />
          </div>
          <div className="col-12 text-left mt-3">
            <TextField
              required
              InputProps={{
                readOnly: true,
              }}
              fullWidth
              name="institutionName"
              label="Institution Name"
              placeholder="Institution Name"
              variant="outlined"
              value={request.name || ""}
            />
          </div>
          <div className="col-12 text-left mt-3">
            <TextField
              type="text"
              fullWidth
              name="acronym"
              label="Acronym"
              placeholder="Acronym"
              variant="outlined"
              value={request.acronym || ""}
              InputProps={{
                readOnly: true,
              }}
            />
          </div>

          <div className="col-12 text-left mt-3">
            <FormControl required fullWidth>
              <InputLabel id="organizationType">Organization type</InputLabel>
              <Select
                readOnly={true}
                labelId="organizationType"
                id="organizationTypeSelect"
                value={request.organizationTypeId}
                label="Organization type"
              >
                {organizationTypes.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="col-12 text-left mt-3">
            <TrainingProviderProgramsDialog trainingProvider={request} />
          </div>
          <div className="col-12 text-left mt-3">
            <TextField
              required
              type="text"
              fullWidth
              name="phone"
              label="Phone"
              placeholder="07XXXXXXXX"
              variant="outlined"
              value={request.phone}
              InputProps={{
                autoComplete: "phone",
                readOnly: true,
              }}
            />
          </div>
          <div className="col-12 text-left mt-3">
            <TextField
              required
              type="email"
              fullWidth
              name="email"
              label="Email"
              placeholder="Email"
              variant="outlined"
              value={request.email}
              InputProps={{
                autoComplete: "email",
                readOnly: true,
              }}
            />
          </div>

          <div className="col-12 mt-3">
            <TrainingProviderAttachmentsDialog trainingProvider={request} />
          </div>

          <div className="col-12 text-left mt-2">
            {!!request.statusName && (
              <span
                className={`d-block badge badge-${request.statusId === 2 ? "success" : request.statusId === 3 ? "danger" : "secondary"}`}
              >
                {request.statusName}
              </span>
            )}
          </div>
        </div>
        {!!statusId && (
          <ConfirmationDialog
            disabled={statusId === 3 && !statusComment}
            confirmationDialog={!!statusId}
            message={
              <>
                <p className="mt-2">
                  Are you sure you want to{" "}
                  <strong
                    className={`text-${statusId === 2 ? "success" : "danger"}`}
                  >
                    {statusId === 2 ? "approve" : "reject"}
                  </strong>{" "}
                  this request?
                </p>
                {statusId === 3 && (
                  <TextField
                    multiline
                    rows={3}
                    autoFocus
                    fullWidth
                    type="text"
                    size="small"
                    name="reason"
                    label="Reason for rejection"
                    variant="outlined"
                    placeholder="Reason for rejection"
                    value={statusComment}
                    onChange={(e) => {
                      setStatusComment(e.target.value || "");
                    }}
                  />
                )}
              </>
            }
            setConfirmationDialog={(e) => setStatusId(null)}
            onYes={() => {
              approveMembershipRequest(
                {
                  requestId: request.id,
                  statusId,
                  statusComment,
                },
                () => {
                  setStatusId(null);
                  onClose();
                },
              );
            }}
          />
        )}
      </DialogContent>

      <DialogActions className="d-flex py-2 justify-content-center">
        {request.statusId === 1 && (
          <>
            <Button
              variant="contained"
              color="success"
              onClick={() => {
                setStatusId(2);
              }}
              type="button"
              className="px-4"
              disabled={loading}
            >
              Approve
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => {
                setStatusId(3);
              }}
              type="button"
              className="px-4"
              disabled={loading}
            >
              Reject
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = ({ user, loading, programs, organizationTypes }) => {
  return {
    user,
    loading,
    programs,
    organizationTypes,
  };
};

export default connect(mapStateToProps, {
  approveMembershipRequest,
  getSchoolSubLevelSubjects,
})(PreviewTrainingProviderDialog);
